/// <amd-module name="Test/TestResultsFilter/DataSourceFilterValueProvider" />
import { union } from "Test/common-util/Common.Utils";
import { FilterValue } from "Test/common-util/Contracts/Filters";
import { FilterValueItem, getDisplayValue } from "Test/common-util/TestResults.Filtering.Common";
import * as Resources from "Test/TestResultsFilter/Resources";
import { ITestResultsFilterItem, ITestResultsFilterItemProvider, ITestResultsFilterPickListItem } from "Test/TestResultsFilter/Types";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";

/** Default filter value provider to be used if no custom one is set */
export class DataSourceFilterValueProvider implements ITestResultsFilterItemProvider {
    constructor(protected fieldName: string) {
    }

    public getItemsForValues(values: FilterValue[]): ITestResultsFilterItem[] {
        return this.transformResults(values);
    }

    public getListItem(filterItem: ITestResultsFilterItem): ITestResultsFilterPickListItem {
        return {
            key: filterItem.key,
            name: filterItem.display,
            value: filterItem.value,
            disabled: filterItem.disabled
        };
    }

    protected transformResults(uniqueValues: FilterValue[], persistedValues?: FilterValue[]): ITestResultsFilterItem[] {
        // copy values array before union
        let values = uniqueValues.slice(0);
        if (persistedValues) {
            persistedValues = persistedValues.filter(v => !!v);
            values = union(values, persistedValues, filterValueComparer);
        }
        return values.map(this.transformResult);
    }

    protected transformResult(result: FilterValue): ITestResultsFilterItem {
        let filterItem: ITestResultsFilterItem;
        if (result instanceof FilterValueItem) {
            let res: FilterValueItem = result;
            filterItem = {
                key: res.value,
                value: res,
                display: getDisplayValue(res)
            } as ITestResultsFilterItem;
        }
        else {
            filterItem = {
                key: result,
                value: result,
                display: (result !== "") ? result : Resources.Unspecified
            } as ITestResultsFilterItem;
        }

        return filterItem;
    }
}


export const filterValueComparer: { (a: FilterValue, b: FilterValue): number }
    = (a: FilterValue, b: FilterValue): number => {
        if (typeof a === "string" && typeof b === "string") {
            return localeIgnoreCaseComparer(a, b);
        }else {
            if (a == b) {
                return 0;
            }
            else if (a > b) {
                return 1;
            }
            else {
                return -1;
            }
        }
    };
